export default __webpack_public_path__ + "static/media/9141-ngbxben.689910b6.pdf";